import { Api } from '@/services/Api'

export default {
  get (pk) {
    return Api().get('/account/profile/')
  },
  create (data) {
    return Api().post('/account/profile/', data)
  },
  update (pk, data) {
    return Api().put(`/account/profile/${pk}/`, data)
  },
  partial_update (pk, data) {
    return Api().patch(`/account/profile/${pk}/`, data)
  }
}
